module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img3-5fcae6a21696031829b7a3e44c74e90a.svg";